import { render } from "./MSALSignin.vue?vue&type=template&id=34484176"
import script from "./MSALSignin.vue?vue&type=script&lang=js"
export * from "./MSALSignin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__